import { render, staticRenderFns } from "./task_evaluation.vue?vue&type=template&id=bd7f37d4&scoped=true&"
import script from "./task_evaluation.vue?vue&type=script&lang=js&"
export * from "./task_evaluation.vue?vue&type=script&lang=js&"
import style0 from "./task_evaluation.vue?vue&type=style&index=0&id=bd7f37d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7f37d4",
  null
  
)

export default component.exports